export default __webpack_public_path__ + "static/media/insight-details.3ab7266c.svg";